
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/guild/2024_08_02",
      function () {
        return require("private-next-pages/[locale]/legal/guild/2024_08_02.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/guild/2024_08_02"])
      });
    }
  